import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-907e2f8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://apps.apple.com/us/app/topo-maps/id672246353?itsct=apps_box_badge&itscg=30200",
  style: {"display":"inline-block","overflow":"hidden","border-radius":"13px","width":"190px","height":"63px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1375142400",
    alt: "Download on the App Store",
    style: {"border-radius":"13px","width":"190px","height":"63px"}
  })
], -1))

import SimpleHeader from "@/components/SimpleHeader.vue";
import GridPage from "@/components/GridPage.vue";
import { useHead } from "@vueuse/head";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import iPhone12 from "@/components/device-screenshots/iPhone12.vue";
const homePageItems = [
  {
    type: "image",
    bezel: "iPhone",
    title: "Map it.",
    subtitle: "Maps for every backcountry adventure.",
    link: "/info/favorite-maps",
    imgURL: require("@/assets/images/mapSelectionScreenShot.jpg"),
  },
  {
    type: "image",
    bezel: "iPhone",
    title: "Plan it.",
    subtitle: "All the tools you need for a successfull trip into the backcountry.",
    link: "/info/how-i-use-topo-maps-to-plan-a-trip",
    imgURL:
      "https://s3.us-west-2.amazonaws.com/gp.us.images/screenshots/iphone12/planning-elevations.jpeg",
  },
  {
    type: "image",
    bezel: "iPhone",
    title: "Hike it.",
    subtitle: "Go deeper into the backcountry with confidence.",
    link: "/info/progress-on-trail",
    imgURL: require("@/assets/images/progressOnTrailScreenShot.jpg"),
  },
  {
    type: "image",
    bezel: "iPhone",
    title: "Navigate, Even Offline.",
    subtitle:
      "Leave the cell towers behind, plot your course and see your position on the map.",
    link: "/info/downloading-maps",
    imgURL:
      "https://s3.us-west-2.amazonaws.com/gp.us.images/screenshots/iphone12/download-maps.jpeg",
  },
  {
    type: "full-width-black",
    title: "Use the Best Maps.",
    subtitle: "Whatever your backcountry activity, we have the map for you.",
    link: "/info/favorite-maps",
    imgURL:
      "https://s3.us-west-2.amazonaws.com/gp.us.images/screenshots/iphone12/BestMapsLogos.jpg",
  },
  {
    type: "image",
    bezel: "iPhone",
    title: "Photo Overlay",
    subtitle: "See your pics right on the map.",
    link: "/info/photo-overlay",
    imgURL: require("@/assets/images/photo-overlay-screenshot.jpg"),
  },
  {
    type: "image-background",
    title: "Tested on",
    subtitle: "real dirt in the Pacific Northwest.",
  },
  {
    type: "full-width-apple-watch-screenshot",
    title: "Apple Watch App",
    subtitle: "Navigate by raising your wrist.",
    link: "/watch",
    imgURL: require("@/assets/images/apple-watch-map.jpg"),
  },

  {
    type: "image",
    title: "Print Maps",
    subtitle: "Don't rely on tech.",
    link: "/info/printing-maps",
    imgURL: require("@/assets/images/printedMap.jpg"),
  },
  {
    type: "image",
    bezel: "iPhone",
    title: "Import & Export",
    subtitle: "Easily view and share data, including GeoPDF® and GeoTIFF files.",
    link: "/info/geo-spatial-pdfs-tiffs",
    imgURL:
      "https://s3.us-west-2.amazonaws.com/gp.us.images/screenshots/iphone12/import-geopdf.jpeg",
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Share Maps",
    subtitle: "Create web links to shared maps.",
    link: "/info/sharing-trip-info",
    imgURL: require("@/assets/images/createShareLinkScreenshot.jpg"),
  },
  {
    type: "image",
    title: "Web Links",
    subtitle: "View shared maps online or in the app.",
    link: "/info/sharing-trip-info",
    imgURL: require("@/assets/images/webLink.jpg"),
  },

  {
    type: "full-width-carplay-image",
    title: "CarPlay App",
    subtitle: "Your Backroad Copilot",
  },

  {
    type: "image",
    title: "Mac App",
    subtitle: "Plan your next adventure on your Mac.",
    link: "https://apps.apple.com/us/app/topo-maps/id1441675937?mt=12",
    linkText: "Download App",
    imgURL: require("@/assets/images/mac-Overview.jpg"),
  },

  {
    type: "image",
    title: "Apple Vision Pro App",
    subtitle: "Stand on a life size map.",
    link: "/visionPro",
    imgURL: require("@/assets/images/appleVisionPro-LookAround-GlacierNationalPark.jpg"),
  },

  {
    type: "full-width-image",
    title: "Topo Maps+ Pro",
    subtitle: "Go Deeper into the Backcountry",
    link: "/plans",
  },
];

useHead({
  title: "Topo Maps+",
  meta: [
    {
      name: `description`,
      content: "Go deeper into the backcountry",
      "og:title": "Topo Maps+",
      "og:description": "Go deeper into the backcountry",
      "og:image":
        "https://s3.us-west-2.amazonaws.com/gp.us.images/images/TopoMapsCard.jpg",
    },
    {
      name: "apple-itunes-app",
      content: "app-id=672246353",
    },
  ],
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleHeader, {
      background: require('@/assets/images/app-splash-bg.jpg'),
      title: "Topo Maps+",
      subtitle: "Map it. Plan it. Hike it.",
      height: "50vh"
    }, {
      "under-title": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["background"]),
    _createVNode(GridPage, {
      gridItems: homePageItems,
      maxColumns: 2
    })
  ]))
}
}

})